import { ReactNode } from 'react';

import { Box, Button, Grid, Text, Textfield } from '@simplywallst/ui-core';

import { TextFieldContainer } from './styled';
import { NarrativeForm } from '../../utils/schema';
import { ValidationErrors } from '../../utils/validation';
import { useNarrativeBack } from '../../hooks/useNarrativeBack';

type Props = {
  userDisplayName: string;
  isLoading: boolean;
  values: NarrativeForm;
  errors: ValidationErrors<NarrativeForm>;
  onSubmit: () => void;
  onChange: (values: Partial<NarrativeForm>) => void;
  submitLabel: ReactNode;
};

export const NarrativeHeader = ({
  userDisplayName,
  isLoading,
  values,
  errors,
  onSubmit,
  onChange,
  submitLabel,
}: Props) => {
  const { goBack } = useNarrativeBack();

  return (
    <Grid
      gap="24px"
      padding="x3"
      backgroundColor="noir"
      borderRadius="x0"
      borderRadiusLg="x2"
      data-cy-id="narrative-header"
    >
      <TextFieldContainer>
        <Textfield
          hiddenLabel
          label="Narrative title"
          name="narrative-title"
          type="text"
          styleType="standardReverse"
          placeholder="What's your take on this stock"
          value={values.title}
          onChange={(e) => onChange({ title: e.currentTarget.value })}
          error={errors.title}
          onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
        />
      </TextFieldContainer>
      <Grid templateColumns="1fr max-content" justifyContent="space-between">
        <Grid
          templateColumns="max-content max-content"
          gap="8px"
          alignItems="center"
        >
          <Box
            borderRadius="x2"
            height="32px"
            width="32px"
            backgroundColor="chart03"
          >
            <Grid placeContent="center" height="100%" width="100%">
              <Text typography="small" textAlign="center">
                {userDisplayName.substring(0, 2).toUpperCase()}
              </Text>
            </Grid>
          </Box>
          <Text typography="small">{userDisplayName}</Text>
        </Grid>
        <Grid templateColumns="max-content max-content" gap="8px">
          <Button disabled={isLoading} styleType="loudLarge" onClick={goBack}>
            Cancel
          </Button>
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            styleType="louderLarge"
            onClick={onSubmit}
          >
            {submitLabel}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
